import { useMemo } from 'react';
import ReactSelect from 'react-select';
import { selectStyles } from './selectStyles';

export interface SelectOption<V extends number | string = string> {
  value: V;
  label: string;
}

interface SelectProps<V extends number | string, O extends SelectOption<V>> {
  value: O | null;
  onChange: (option: O | null) => void;
  options: O[];
  placeholder?: string;
  isError?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  noOptionsMessage?: string;
}

function Select<V extends number | string, O extends SelectOption<V>>({
  value,
  onChange,
  options,
  placeholder = 'Select…',
  isError = false,
  isDisabled = false,
  isClearable = true,
  noOptionsMessage = 'No options',
}: SelectProps<V, O>) {
  const styles = useMemo(() => selectStyles<O>({ isError, isDisabled }), [isError, isDisabled]);

  return (
    <ReactSelect<O, false>
      value={value}
      onChange={(val) => onChange(val)}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      styles={styles}
      menuPortalTarget={document.body}
      noOptionsMessage={() => noOptionsMessage}
    />
  );
}

export default Select;
